import * as React from 'react'
import { connect } from 'react-redux'

import * as commonActions from 'common/actions'
import { filteredRatesSelector } from 'embed/selectors'
import { OfferOverflowList } from 'embed/constants'
import QueryParams from 'common/services/QueryParams'
import { LoanOffer } from 'embed/constants/models'
import { RedirectPreferredLook, withExperiment } from 'embed/experiments'
import { MultiProductState } from 'embed/reducers'
import { configOfferOverflowSelector, configStateSelector } from 'embed/selectors/config'
import { ratesStateSelector } from 'embed/selectors/rates'
import { Product, ProductResponseKeys, QueryParamKeys } from 'even-ts-static'
import { LoanPreviewView } from './index'

interface LoanPreviewViewProps {
  dispatchLoanOfferPreviewSelected: (offer: LoanOffer) => void
  dispatchSetMaxResults: (maxResults: number) => void
  dispatchSeeAllLoansSelected: () => void
  loanOffers: LoanOffer[]
  seeAllOffersAvailable: boolean
  seeMoreOffersAvailable: boolean
}

const PreviewContainer: React.FC<LoanPreviewViewProps> = ({
  dispatchLoanOfferPreviewSelected,
  loanOffers,
  ...other
}: LoanPreviewViewProps) => (
  <LoanPreviewView dispatchOfferCta={dispatchLoanOfferPreviewSelected} loanOffers={loanOffers} {...other} />
)

const mapStateToProps = (state: MultiProductState) => {
  const loanOffers = filteredRatesSelector(state, {
    offersPath: `${Product.Loan}.loanOffers`,
    product: Product.Loan,
  })

  const totalAvailableOffers =
    ratesStateSelector(state)[Product.Loan][`${ProductResponseKeys[Product.Loan]}Offers`]?.length ?? 0
  const pageSize = configStateSelector(state)[QueryParamKeys.PageSize]

  const hasPartnerKeyQueryParam = QueryParams.get(QueryParamKeys.Partner) !== undefined
  const offerOverflow = configOfferOverflowSelector(state)

  const seeAllOffersAvailable =
    pageSize !== undefined &&
    totalAvailableOffers > pageSize &&
    hasPartnerKeyQueryParam &&
    offerOverflow === OfferOverflowList.PARTNER_LINK

  const seeMoreOffersAvailable = pageSize !== undefined && totalAvailableOffers > pageSize

  const visibleOffers = seeAllOffersAvailable ? loanOffers.slice(0, pageSize) : loanOffers

  return {
    loanOffers: visibleOffers,
    seeAllOffersAvailable,
    seeMoreOffersAvailable,
  }
}

const mapDispatchToProps = (dispatch) => ({
  dispatchLoanOfferPreviewSelected: (offer: LoanOffer) => dispatch(commonActions.loanOfferPreviewSelected(offer)),
  dispatchSeeAllLoansSelected: () => dispatch(commonActions.seeAllLoansSelected()),
  dispatchSetMaxResults: (maxResults) => dispatch(commonActions.setMaxResults(Product.Loan, maxResults)),
})

export const LoanPreviewContainer = withExperiment(RedirectPreferredLook)(
  connect(mapStateToProps, mapDispatchToProps)(PreviewContainer),
)
